import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap";
import "toastr/build/toastr.min.css";
import Breadcrumbs from "components/Common/Breadcrumb";
import { NIL } from "uuid";
import classnames from "classnames";
import {
  getInvoicePaymentHistory,
  getInvoices,
  getUserById,
} from "store/actions";
import UserInfoTab from "./UserInfoTab";

export class UserDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: NIL,
      activeTab: "1",
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidMount() {
    const { match } = this.props;
    const { id, activeTab } = match.params;

    if (id !== NIL) {
      this.setState({
        id,
        activeTab: activeTab ?? "1",
      });
      this.props.getUserById(id);
    }
  }

  populationUserInfo = () => {
    const { id } = this.state;
    this.props.getUserById(id);
  };
  
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>User Detail | JLS Express</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
              title="User Management"
              backLink={"/user"}
              breadcrumbItem="User Detail"
            />

            <Row>
              <Col lg={12}>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "1",
                      })}
                      onClick={() => {
                        this.toggle("1");
                        this.populationUserInfo();
                      }}
                    >
                      Info
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    {this.state.id !== NIL && (
                      <UserInfoTab id={this.state.id} />
                    )}
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

UserDetail.propTypes = {
  loading: PropTypes.bool,
  item: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  getUserById: PropTypes.func,
  getOrders: PropTypes.func,
  getInvoices: PropTypes.func,
  getInvoicePaymentHistory: PropTypes.func,
};

const mapStateToProps = ({ user }) => {
  return user;
};

export default withRouter(
  connect(mapStateToProps, {
    getUserById,
    getInvoices,
    getInvoicePaymentHistory,
  })(UserDetail)
);
